import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { ValoreEconomicoEditRevisioneComponent } from './sezione-economica-valore-edit-revisione.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-valore-edit-revisione]',
  templateUrl: 'sezione-economica-mod-valore-edit-revisione.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ModValoreEconomicoEditRevisioneComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Input() edit: boolean;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formValoreEconomicoRevisione') formValoreEconomicoRevisione: ValoreEconomicoEditRevisioneComponent;

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlUpdate: string, recuperoCrediti: boolean = false) {
    openModal('modaleValoreEconomicoRevisioneEdit');
      this.formValoreEconomicoRevisione.inizializza(sezione, petitumRevisione, fascicolo, urlUpdate, recuperoCrediti);
  }

  createForm() {
      this.formValoreEconomicoRevisione.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleValoreEconomicoRevisioneEdit');
      this.onReturn.emit(sezioneEconomica);
  }
}
